import React, { useContext, useState, useEffect } from 'react';
import AdmExecutaEtapa from '../../components/AdmExecutaEtapa/AdmExecutaEtapa';

export function excluiEstatisticas(props) { 
    return (
        <AdmExecutaEtapa QualEtapa="Excluir Estatisticas"></AdmExecutaEtapa>        
        );
}
